export const formatDate = function(timestamp: string) {
    const date = new Date(timestamp);
    return date.toLocaleDateString();
}